import {hideData, isEmpty, isJson, showData} from 'react-lf-tools'

const authkey = import.meta.env.VITE_AUTHKEY
const idStore = import.meta.env.VITE_ID_STORE
const indexStore = import.meta.env.VITE_INDEX_STORE

const getLocal = (key, valueDefault = '') => {
    const data = localStorage.getItem(`bitmenu_cardapio_digital-${authkey}_${idStore}_${indexStore}:${key}`)
    if (isEmpty(data)) {
        return valueDefault
    } else {
        if (isJson(data))
            return JSON.parse(data)
        else
            return showData(data)
    }
}

const setLocal = (key, data = {}, encrypt = true) => {
    localStorage.setItem(`bitmenu_cardapio_digital-${authkey}_${idStore}_${indexStore}:${key}`, (encrypt) ? hideData(data) : JSON.stringify(data))
}

const removeLocal = (key) => {
    localStorage.removeItem(`bitmenu_cardapio_digital-${authkey}_${idStore}_${indexStore}:${key}`)
}

const clearLocal = () => localStorage.clear()

const getSession = (key, valueDefault = '') => {
    const data = sessionStorage.getItem(`bitmenu_cardapio_digital-${authkey}_${idStore}_${indexStore}:${key}`)
    if (isEmpty(data)) {
        return valueDefault
    } else {
        if (isJson(data))
            return JSON.parse(data)
        else
            return showData(data)
    }
}

const setSession = (key, data = {}, encrypt = true) => sessionStorage.setItem(`bitmenu_cardapio_digital-${authkey}_${idStore}_${indexStore}:${key}`, (encrypt) ? hideData(data) : JSON.stringify(data))

const removeSession = (key) => sessionStorage.removeItem(`bitmenu_cardapio_digital-${authkey}_${idStore}_${indexStore}:${key}`)

const clearSession = () => sessionStorage.clear()

export {
    getLocal,
    setLocal,
    removeLocal,
    clearLocal,
    getSession,
    setSession,
    removeSession,
    clearSession
}
